// import CToast from "../CToast";
import { useDeletePost } from "modules/Community/hooks";
import CToast from "../CToast";
import { ButtonConfirm } from "../form-controls";
import { _t } from "core/language";
import { useEffect, useState } from "react";
export type IProps = {
  className?: string;
  creatorId?: number;
  id?: number;
  type?: 'post' | 'comment';
  handleClick?: (e: any) => void;
  onClose?: (e?: any) => void;
};

const CDelete = ({
  className,
  creatorId,
  type = 'post',
  id,
  handleClick,
  onClose
}: IProps) => {
const { handleDeletePost, loadingDeletePost } = useDeletePost()
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (!loadingDeletePost && loading) {
      handleClick?.(id)
      CToast(_t("comunity.toast_delete"))
      setLoading(false)
    } 
  }, [loadingDeletePost])

  const handleAction = (type: any) => {
    console.log(creatorId, id, 'handleToPage1', type)
    handleDeletePost(id)
    setLoading(true)
  }

  return (<>
    {type === 'post' ? <ButtonConfirm
      label={_t("comunity.confirm_delete")}
      classBtn={`w-[104px] ${className}`}
      handleSubmit={() => handleAction('DELETE')}
      submitText={_t("comunity.text_yes")}
      closeText={_t("comunity.text_no")}
      message={
        <div>{_t("comunity.confirm_delete")}</div>
      }
      onClose={() => {onClose?.()}}
    > {_t("comunity.delete_post")}</ButtonConfirm> : <ButtonConfirm
      label={_t("comunity.confirm_delete")}
      classBtn={`w-[104px] ${className}`}
      handleSubmit={() => handleAction('DELETE')}
      submitText={'yes'}
      closeText={'no'}
      message={
        <div>{_t("comunity.confirm_delete_comment")}</div>
      }
      onClose={() => {onClose?.()}}
    > <label className="text-[12px] text-[#777777]">{_t("comunity.delete_comment")}</label></ButtonConfirm>}
  </>)
}

export default CDelete;